import {useState} from 'react';
import {useDTMF} from '../../../components/Dialer/hooks/DTMFToneHook';
import {KEYPAD_KEYS} from './keypadKeys';

export const CallKeypad = ({onDigit}: {onDigit: (digit: string) => void}) => {
    const [typed, setTyped] = useState('');
    const {playToneForDuration} = useDTMF();
    const press = (digit: string) => {
        playToneForDuration(digit);
        setTyped(current => `${current}${digit}`.slice(-24));
        onDigit(digit);
    };
    return (
        <div className="flex flex-col gap-3" data-testid="call-keypad">
            <p aria-live="polite" className="h-8 truncate text-center text-2xl font-semibold tabular-nums">{typed}</p>
            <div className="grid grid-cols-3 gap-2">
                {KEYPAD_KEYS.map(key => (
                    <button
                        key={key.digit}
                        type="button"
                        aria-label={key.digit}
                        onClick={() => press(key.digit)}
                        className="phq-call-press flex h-12 flex-col items-center justify-center rounded-[10px] bg-[var(--phq-call-surface-muted)]"
                    >
                        <span className="text-xl font-semibold leading-[1.1]">{key.digit}</span>
                        <span className="h-2.5 text-[11px] font-semibold leading-[10px] tracking-[.08em] text-[var(--phq-call-ink-muted)]">{key.letters}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
